import { selector } from 'recoil'
import { CheckpointsMap } from './projectCheckpoints.types'
import allCheckpointsAtom from './allCheckpoints.atom'

const checkpointsMap = selector({
  key: 'selectors/project-checkpoints-map',
  get: ({ get }): CheckpointsMap => {
    const state = get(allCheckpointsAtom)

    return state.items.reduce((acc, val) => ({ ...acc, [val.id]: val}), {})
  },
})

const checkpointsSelectors = { checkpointsMap }
export default checkpointsSelectors
